import { Component, Input } from '@angular/core';
import { Event } from '@models/community/event.model';
import { AsyncPipe, DatePipe, NgClass, NgIf } from '@angular/common';
import { CommonComponent } from '@components/common.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AttendeePipe } from '@calendar/pipes/attendee.pipe';
import { RouterLink } from '@angular/router';
import moment from 'moment/moment';
import { EventCardComponent } from '@calendar/components/event-card/event-card.component';

@Component({
  selector: 'app-calendar-event-details',
  standalone: true,
  imports: [
    DatePipe,
    NgIf,
    NgClass,
    SimplebarAngularModule,
    AsyncPipe,
    AttendeePipe,
    RouterLink,
    EventCardComponent,
  ],
  templateUrl: './calendar-event-details.component.html',
  styles: ``,
})
export class CalendarEventDetailsComponent extends CommonComponent {
  mm = moment;

  @Input() data: Event | null = null;
  @Input() type: 'COMMUNITY' | 'USER' = 'COMMUNITY';
}
